import { render, staticRenderFns } from "./ApprovedTable.vue?vue&type=template&id=6cc380d0"
import script from "./ApprovedTable.vue?vue&type=script&lang=js"
export * from "./ApprovedTable.vue?vue&type=script&lang=js"
import style0 from "./ApprovedTable.vue?vue&type=style&index=0&id=6cc380d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports